import { AuthSource } from '@framework/auth/AuthSource.ts';
import { setAuthGlobalOptions } from '@framework/auth/options.ts';

setAuthGlobalOptions({
  requiresRoleSelection: false,
  storageKey: 'fwpfoauth',
  source: AuthSource.FrontOffice,
});
